// eslint-disable import/no-named-as-default
import ReactDOM from 'react-dom'
import { ApolloProvider } from '@apollo/client/react'
import { ApolloClient, InMemoryCache } from '@apollo/client'
import { BrowserRouter } from 'react-router-dom'
import ErrorBoundary from './modules/errorBoundary/errorBoundary'
import AppLayout from './modules/layout/appLayout'
import { isOnEnv } from './config/connections'
import AppRouter from './appRouter'

const client = new ApolloClient({ cache: new InMemoryCache(), uri: '' })

ReactDOM.render(
  <ApolloProvider client={client}>
    <ErrorBoundary>
      <AppLayout>
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
      </AppLayout>
    </ErrorBoundary>
  </ApolloProvider>,
  document.getElementById('app')
)

if (!isOnEnv('prod')) {
  // eslint-disable-next-line global-require
  const reportWebVitals = require('./reportWebVitals').default
  // eslint-disable-next-line no-console
  reportWebVitals(console.log)
}
